import React, { useState } from 'react'
import { Menu, X } from 'lucide-react'

const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/nowpilot-ai-copilot-for-f/fbcdieoakcimbcaeblflmolklimhlnii'
const LOGO_URL = 'https://iyuecznfxavbpwsapptp.supabase.co/storage/v1/object/public/images/NowPilot-riposte-logo/np-riposte-logo-full-color.svg'

declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

const NAV_LINKS = [
  { href: '#how-it-works', label: 'How it works' },
  { href: '#team', label: 'Team' },
]

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleChromeStoreClick = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'chrome_store_click', {
        event_category: 'engagement',
        event_label: 'header_cta'
      })
    }
    window.open(CHROME_STORE_URL, '_blank', 'noopener')
  }

  return (
    <>
      <div className="w-full bg-sand/70 text-center px-4 py-2 text-xs text-ink-mute border-b border-ink/5">
        <span className="font-mono uppercase tracking-wider text-[10px] text-ink-soft mr-2">New</span>
        NowPilot is now a Chrome extension.{' '}
        Looking for the{' '}
        <a href="https://nowpilot.ai/web" className="underline decoration-ink/30 underline-offset-2 hover:text-ink hover:decoration-ink transition-colors">web app</a>
        {' or '}
        <a href="https://nowpilot.ai/downloads/win" className="underline decoration-ink/30 underline-offset-2 hover:text-ink hover:decoration-ink transition-colors">desktop</a>
        {' version?'}
      </div>

      <header className="sticky top-0 z-40 w-full bg-paper/85 backdrop-blur border-b border-ink/10">
        <div className="container mx-auto px-4 max-w-6xl flex items-center justify-between h-14">
          <a href="#top" className="flex items-center gap-2.5">
            <img src={LOGO_URL} alt="" aria-hidden className="h-7 w-auto" />
            <span className="font-display text-xl text-ink tracking-tight leading-none">
              NowPilot
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-7">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-ink-mute hover:text-ink transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={handleChromeStoreClick}
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-1.5 bg-ink text-white text-sm font-medium rounded-full hover:bg-ink/90 transition-colors"
            >
              Add to Chrome
            </button>
            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              className="md:hidden p-1.5 text-ink-mute hover:text-ink"
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-ink/10 bg-paper">
            <nav className="container mx-auto px-4 max-w-6xl py-4 flex flex-col gap-4">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-sm text-ink-mute"
                >
                  {link.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setMobileOpen(false)
                  handleChromeStoreClick()
                }}
                className="mt-1 inline-flex items-center justify-center px-4 py-2 bg-ink text-white text-sm font-medium rounded-full"
              >
                Add to Chrome
              </button>
            </nav>
          </div>
        )}
      </header>
    </>
  )
}
